import apiHandler from "../core/apiHandler";

const quotationItemApi = apiHandler("quotations");

export default quotationItemApi;